module.exports = __webpack_public_path__ + "static/media/page_not_found.71c89504.svg";